"use strict";

define('model/heartbeat',['datakit/ajax', './base', 'underscore', 'vertebrae', 'rs/models/session', 'rs/errors', 'backbone.radio'], function (ajax, Base, _, Vertebrae, Session, RSError, Radio) {
  var Heartbeat = Base.extend({
    urlRoot: '/rs/public/heartbeat',
    intervalTime: 60000,
    errorCount: 0,
    defaults: {
      uiActivityDetected: false
    },
    parse: function parse(resp) {
      if (resp.valid === true) {
        return resp.data;
      }
      throw new RSError.IgnoredError();
    },
    initialize: function initialize() {
      var channel = Radio.channel('session'),
        self = this;
      Base.prototype.initialize.apply(this, arguments);
      this.on('sync', this.onSync).on('error', this.onError).listenTo(channel, 'activity', function (type, value) {
        if (value == null) {
          this.unset(type);
        } else {
          this.set(type, value);
        }
      }).listenTo(channel, 'clear:heartbeat', function () {
        this.stop();
      }).listenTo(channel, 'fetch:heartbeat', function () {
        ajax.abort('heartbeat');
        this.fetch({
          pool: 'heartbeat'
        });
      });
      channel.reply('fetch:heartbeat', function (options) {
        return self.fetch(_.extend({}, options, {
          pool: 'heartbeat'
        })).promise().then(function () {
          return self;
        });
      });
    },
    onSync: function onSync(model, resp, options) {
      var response = this.get('response');
      if (this.previous('response') !== response && (response == 'NO_SESSION' || response == 'LOGOUT')) {
        if (!options.silent) {
          Vertebrae.Event.trigger('sessionExpire', 'timeout');
        }
      } else if (!options.silent) {
        _.each(this.changedAttributes(), function (value, key) {
          var previousValue = this.previous(key);
          if (value != previousValue) {
            Vertebrae.Event.trigger(key, value);
            Session.trigger(key, value);
            Radio.channel('global').trigger('heartbeat:change:' + key);
          }
        }, this);
        Vertebrae.Event.trigger("heartbeatRespondedWith" + response);
        this.set('uiActivityDetected', false);
        this.errorCount = 0;
      }
    },
    onError: function onError(e) {
      console.error('Error while contacting Heartbeat: ' + e);
      console.error(arguments);
      this.errorCount++;
      if (this.errorCount > 3) {
        this.errorCount = 0;
        Vertebrae.Event.trigger('sessionExpire', 'log-out');
      }
    },
    sync: function sync(method, model, options) {
      return Base.prototype.sync.call(this, 'update', model, options);
    },
    start: function start() {
      var self = this;
      var listenForInterfaceMovement = function listenForInterfaceMovement() {
        if (!self._mouseEventExists) {
          self._mouseEventExists = true;
          $(document.body).one("mousemove", function () {
            self._mouseEventExists = false;
            self.set('uiActivityDetected', true);
          });
        }
        if (!self._keyEventExists) {
          self._keyEventExists = true;
          $(document.body).one("keydown", function () {
            self._keyEventExists = false;
            self.set('uiActivityDetected', true);
          });
        }
      };
      listenForInterfaceMovement();
      this.fetch();
      this._interval = setInterval(function () {
        listenForInterfaceMovement();
        self.fetch();
      }, this.intervalTime);
      return this;
    },
    stop: function stop() {
      clearInterval(this._interval);
      return this;
    }
  });
  return Heartbeat;
});

